import { SpringAPI } from 'defs/http/api';
import axios from 'helper/axios-facade';
import { warn } from 'helper/debug';
import appConfig from 'helper/mapBackendConfig';

export const fetchAsyncEvents = () => {
	const requestUrl = SpringAPI.notifications.getNotifications();

	return axios.get(requestUrl).catch((err) => {
		warn(`fetchAsyncEvents(...): Polling failed - ${err}`);
	});
};

export const putEventToRead = (notificationId: string) => {
	if (!notificationId) {
		throw Error('Unknown Event ID');
	}

	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/notifications/${notificationId}`;

	return axios.put(requestUrl);
};

export const fetchCustomOverlays = () => {
	const requestURL = `${appConfig.env.urlMagnoliaAPICoach}/overlay`;

	return axios.get(requestURL, {
		withCredentials: false,
	});
};

export const fetchProfileCustomOverlays = () => {
	const requestUrl = SpringAPI.overlays.getCustomOverlays();

	return axios.get(requestUrl);
};

export const putCustomOverlayShown = ({ overlayId }) => {
	const requestUrl = SpringAPI.overlays.putCustomOverlays({ id: overlayId });

	return axios.put(requestUrl);
};
